import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import extraReducers from './extraReducers';
import dayjs from 'dayjs';

export * from '../../thunk/modelFrontLogs';

const ModelFrontLogsSlice = createSlice({
    name: 'modelFrontLogs',
    initialState: {
        data: null,
        status: null,
        error: null,
        queryParams: {
            limit: 50,
            page: 1,
            sortDirection: 'DESC',
            createdAtMin: dayjs().format('YYYY-MM-DD'),
            createdAtMax: dayjs().format('YYYY-MM-DD'),
        },
        singleLog: null,
        singleLogStatus: null,
        singleLogError: null,
    },
    reducers,
    extraReducers,
});

const { actions, reducer } = ModelFrontLogsSlice;
export const { setModelFrontLogsQueryParams, clearModelFrontLogsFilters } = actions;
export { reducer };
